import { DistributorParams } from "./shared-dto";

export class RenaultPuntoapuntoLocalCampaignSegmentationDTO {
    IdSegmentation: string | null;
    Status: boolean;
    Title: string;
    IdPvGroup?: number;
    ShowMySegmentations: boolean;
    Filters: LocalCampaignSegmentationFilter;
    Family?: RenaultPuntoapuntoLocalCampaignSegmentationFamilyDTO[];
    Segment?: RenaultPuntoapuntoLocalCampaignSegmentationSegmentDTO[];
    Fidelity?: RenaultPuntoapuntoLocalCampaignSegmentationFidelityDTO[];
}

export class LocalCampaignSegmentationFilter {
    Rol: string[] = [];
    Distributor: DistributorParams = new DistributorParams();
    CP: string[] = [];
    PvpMin: number | null;
    PvpMax: number | null;
    LogInitDate: string | null;
    LogEndDate: string | null;
    MinPoints: number | null;
    MaxPoints: number | null;
    IdTresor: { [key: number]: number[][] };
    FamilyFilter: GetIdTresorByFamilyFilter | null;
    FidelityFilter: GetIdTresorByFamilyFidelityFilter[] = [];
}




export class RenaultPuntoapuntoCrmEntity {
    Entity: RenaultPuntoapuntoCrmEntityTable[];
    Result: RenaultPuntoapuntoCrmResultTable[];
}

export class RenaultPuntoapuntoCrmEntityTable {
    IdTresor: number;
    Name: string;
    Email: string;
    Rol: string;
    DistributorName: string;
}

export class RenaultPuntoapuntoCrmResultTable {
    Total: number = 0;
    TotalAvailable: number = 0;
    R2: number = 0;
    R3: number = 0;
    Motrio: number = 0;
    Stopcom: number = 0;
    Impacted: number = 0;
}


export class FamilyGroupBySegmentModelDTO {
    Segment: string;
    IdSegment?: number;
    Description?: string;
    Familiy: PuntoapuntoFamilyDTO[];
}

export class PuntoapuntoFamilyDTO {
    IdFamily: string;
    IdFamilyInt: number;
    IdSegment: number;
    Family: string;
    Description: string;
}

export class FamilyGroupSelectionDTO {
    IdSegment: number;
    Segment: string;
    SegmentDescription?: string;
    Families: FamilySelectionDTO[];
}

export class SegmentGroupSelectionDTO {
    IdSegment: number;
    Segment: string;
    SegmentDescription?: string;
    PvpMin: number | null;
    PvpMax: number | null;
}

export class FamilySelectionDTO {
    IdSegment: number;
    IdFamily: number;
    Family: string;
    Description: string;
    PvpMin: number | null;
    PvpMax: number | null;
}


export class RenaultPuntoapuntoLocalCampaignSegmentationFamilyDTO {
    IdSegment: number;
    Segment: string;
    IdFamily: number;
    Family: string;
    Description: string;
    PvpMin: number | null;
    PvpMax: number | null;
}

export class RenaultPuntoapuntoLocalCampaignSegmentationSegmentDTO {
    IdSegment: number | null;
    Segment: string | null;
    Description: string | null;
    PvpMin: number | null;
    PvpMax: number | null;
}


export class RenaultPuntoapuntoLocalCampaignSegmentationFidelityDTO {
    IdSegmentation: number;
    IdRol: number;
    IdPercent: number;
}

export class GetIdTresorByFamilyFilter {
    InitDate: string | null;
    EndDate: string | null;
    Rols: number[] | null;
    IsUnits: boolean = false;
    PvpMin: number | null;
    PvpMax: number | null;
    Family: GetIdTresorByFamilyDataFilter[] = [];
    Segment: GetIdTresorBySegmentDataFilter[] = [];
    Fidelity: GetIdTresorByFamilyFidelityFilter[] = [];
}

export class GetIdTresorByFamilyDataFilter {
    IdFamily: number;
    PvpMin: number | null;
    PvpMax: number | null;
    IdRol: number;
}

export class GetIdTresorByFamilyFidelityFilter {
    InitDate: string | null;
    IdPercent: number;
    Percent1: number | null;
    Percent2: number | null;
    IdRol: number;
}

export class GetIdTresorBySegmentDataFilter {
    IdSegment: number;
    PvpMin: number | null;
    PvpMax: number | null;
    IdRol: number;
}
